export default "__VITE_ASSET__BhP2x3L3__"